import React from 'react';

export enum ShadowType {
    NONE,
    SMALL,
    MEDIUM,
    LARGE,
}

export function getElementShadow(type?: ShadowType): React.CSSProperties {
    switch (type) {
        case ShadowType.NONE:
            return {};
        case ShadowType.SMALL:
            return {
                boxShadow: '0 0.0625em 0.1875em 0 rgb(0 0 0 / 0.1), 0 0.0625em 0.125em -0.0625em rgb(0 0 0 / 0.1);',
            };
        case ShadowType.MEDIUM:
            return {
                boxShadow: '0 0.25em 0.375em -0.0625em rgb(0 0 0 / 0.1), 0 0.125em 0.25em -0.125em rgb(0 0 0 / 0.1)',
            };
        case ShadowType.LARGE:
            return {
                boxShadow: '0 0.625em 0.9375em -0.1875em rgb(0 0 0 / 0.1), 0 0.25em 0.375em -0.25em rgb(0 0 0 / 0.1)',
            };
        default:
            return {};
    }
}
